<template>
  <div class="files-table-container">
    <!--datatable class='files-table'></datatable-->
    <div class="file-list">
      <div class="file-item header-item">
        <div style="width: 100px">Bild</div>
        <div class="flex-1">Dateiname</div>
        <div class="flex-1">Gültig ab</div>
        <div class="flex-1">Gültig bis</div>
        <div class="flex-1">Beschreibung</div>
        <div class="flex-1">Aktionen</div>
      </div>
      <div
        class="file-item"
        v-for="file in [...promoFiles, ...(softDeletedFiles || [])]"
        :key="`${file.id}-${file.deleted_at}` /* to avoid duplicate keys when deleting, can be removed when deleted items get their own v-for */"
      >
        <a
          v-if="blobUrls[file.id]"
          :href="blobUrls[file.id].full"
          target="_blank"
        >
          <img
            :class="{
              'thumbnail-active': isPromoActive(file),
              'thumbnail-inactive': !isPromoActive(file),
              'thumbnail-trashed': !!file.deleted_at,
            }"
            class="thumbnail"
            :src="blobUrls[file.id].thumbnail"
            :alt="file.name"
          />
        </a>
        <div v-else class="thumbnail thumbnail-trashed">?</div>
        <!-- default view -->
        <template v-if="!editingPromoFile || editingPromoFile.id !== file.id">
          <div class="flex-1">{{ file.name }}</div>
          <div class="flex-1" v-if="file.validFrom">
            {{ file.validFrom | formatDate }}
          </div>
          <div class="flex-1" v-else>Gültig ab festlegen...</div>
          <div class="flex-1" v-if="file.validTo">
            {{ file.validTo | formatDate }}
          </div>
          <div class="flex-1" v-else>Dauerhaft gültig</div>
          <div class="flex-1">
            {{ file.description || "-" }}
          </div>
          <div class="flex-1 actions">
            <b-toaster
              class="delete-toaster"
              :name="`toaster-${file.id}`"
              :ref="`toaster${file.id}`"
            ></b-toaster>
            <buttonc
              v-if="!file.deleted_at"
              icon="fa-pen"
              title="Bearbeiten"
              :disabled="!canEdit"
              @click="editingPromoFile = { ...file }"
            />

            <!-- restore btn -->
            <buttonc
              v-else
              icon="fa-undo"
              :title="
                canDelete
                  ? 'Wiederherstellen'
                  : 'Keine Berechtigung zum Wiederherstellen'
              "
              @click="restoreFile(file)"
            />

            <!-- delete btn -->
            <buttonc
              icon="fa-trash"
              :title="canDelete ? 'Löschen' : 'Keine Berechtigung zum Löschen'"
              :disabled="!canDelete"
              @click="showDeleteDialog(file)"
            />

            <b-toast
              :id="`delete-file-toast-${file.id}`"
              :title="
                file.deleted_at
                  ? 'Promotion permanent löschen?'
                  : 'Promotion löschen?'
              "
              variant="danger"
              :toaster="`toaster-${file.id}`"
              no-auto-hide
              no-fade
            >
              <div style="display: flex">
                <p v-if="!file.deleted_at">
                  Sie können die Promotion innnerhalb von 7 Tagen
                  wiederherstellen
                </p>
                <p v-else>
                  Dadurch kann sie nicht mehr wiederhergestellt werden!
                </p>
                <buttonc
                  icon="fa-trash"
                  type="red no-background"
                  @click="deleteFile(file, !!file.deleted_at)"
                />
              </div>
            </b-toast>
          </div>
        </template>
        <!-- edit view -->
        <template v-else>
          <div class="flex-1">
            <b-form-input
              type="text"
              v-model="editingPromoFile.name"
              :state="editingPromoFile.name.trim() === '' ? false : null"
              placeholder="Dateiname"
            />
          </div>
          <div class="flex-1">
            <b-form-datepicker
              v-model="editingPromoFile.validFrom"
              today-button
              reset-button
              close-button
            />
          </div>
          <div class="flex-1">
            <b-form-datepicker
              v-model="editingPromoFile.validTo"
              today-button
              reset-button
              close-button
            />
          </div>
          <div class="flex-1">
            <b-form-input
              type="text"
              v-model="editingPromoFile.description"
              placeholder="Beschreibung hinzufügen..."
            />
          </div>
          <div class="flex-1 actions">
            <buttonc
              icon="fa-check"
              title="Speichern"
              :disabled="editingPromoFile.name.trim() === ''"
              @click="updateFile(editingPromoFile)"
            />
            <buttonc
              icon="fa-times"
              title="Abbrechen"
              @click="editingPromoFile = null"
            />
          </div>
        </template>
      </div>
      <buttonc
        v-if="!this.softDeletedFiles"
        label="Gelöschte Promos laden"
        @click="refreshSoftDeletes()"
      />
      <buttonc v-else label="Tabelle neu laden" @click="refresh()" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import buttonc from "@/components/uicomponents/button";
// import datatable from '@/components/uicomponents/datatable';

export default {
  components: {
    buttonc,
    // datatable
  },
  props: {
    promotionId: Number,
    canEdit: Boolean,
    canDelete: Boolean,
  },
  data() {
    /**
     * PromoFileInterface
     *
     * @interface
     * @property {number} id
     * @property {string} name
     * @property {string} description
     * @property {string} mimeType
     * @property {string} fileSize
     * @property {?string} validFrom
     * @property {?string} validTo
     * @property {?string} deleted_at
     */
    function PromoFile() {}

    /**
     * @type {PromoFile[]}
     */
    const promoFiles = [];

    /**
     * @type {?PromoFile[]}
     */
    const softDeletedFiles = null;

    /**
     * @type {{number: {thumbnail: string,full:string}}}
     */
    const blobUrls = {};

    /**
     * @type {PromoFile} editingPromoFile The promo file that is currently edited
     */
    const editingPromoFile = null;
    return {
      promoFiles,
      softDeletedFiles,
      editingPromoFile,
      blobUrls,
    };
  },
  created() {
    this.refresh(false);
  },
  watch: {
    promotionId() {
      this.refresh(false);
    },
  },
  methods: {
    async refresh(withSoftDeletes = true) {
      if (!this.promotionId) return;
      try {
        const response = await axios.get("/api/sec/files", {
          params: { promotionId: this.promotionId },
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
          },
        });
        const promoFiles = response.data.data;
        this.loadImageBlobs(promoFiles).catch();
        this.promoFiles = promoFiles;
      } catch (error) {
        this.$bvToast.toast(error.message, {
          appendToast: true,
          autoHideDelay: 3000,
          toaster: "b-toaster-bottom-center",
          variant: "danger",
          title: "Fehler beim Laden der Dateien",
        });
      }
      if (withSoftDeletes) await this.refreshSoftDeletes();
      else this.softDeletedFiles = null;
    },
    async refreshSoftDeletes() {
      try {
        const response = await axios.get("/api/sec/files", {
          params: { promotionId: this.promotionId, onlyDeleted: 1 },
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
          },
        });
        console.log("FilesTable soft deleted files", response);
        const softDeletedFiles = response.data.data;
        this.loadImageBlobs(softDeletedFiles).catch();
        this.softDeletedFiles = softDeletedFiles;
      } catch (error) {
        this.$bvToast.toast(error.message, {
          appendToast: true,
          autoHideDelay: 3000,
          toaster: "b-toaster-bottom-center",
          variant: "danger",
          title: "Fehler beim Laden der gelöschten Dateien",
        });
      }
    },
    // loads image blobs
    async loadImageBlobs(promoFiles = null) {
      const headers = {
        Authorization: "Bearer " + this.$store.state.jwt,
      };

      if (!promoFiles)
        promoFiles = [...this.promoFiles, ...(this.softDeletedFiles || [])];

      // get image blobs
      for (const promoFile of promoFiles) {
        // only load new files
        if (this.blobUrls[promoFile.id]) continue;

        const imgBaseUrl = `/api/sec/files/${promoFile.id}/download?action=download`;

        // load thumbnail first
        const thumbRes = await axios
          .get(`${imgBaseUrl}&full=0`, {
            headers,
            responseType: "blob",
          })
          .catch(() => {});

        const fullRes = await axios
          .get(`${imgBaseUrl}&full=1`, {
            headers,
            responseType: "blob",
          })
          .catch(() => {});

        const blobObject = {
          thumbnail: URL.createObjectURL(thumbRes.data),
          full: URL.createObjectURL(fullRes.data),
        };

        this.$set(this.blobUrls, promoFile.id, blobObject);
      }
    },
    /**
     * @param {PromoFile} file
     * @return {boolean}
     */
    isPromoActive(file) {
      const now = Date.now();
      const validFrom = file.validFrom ? Date.parse(file.validFrom) : null;
      const validTo = file.validTo ? Date.parse(file.validTo) : null;
      return (
        !file.deleted_at &&
        !!validFrom &&
        validFrom < now &&
        (!validTo || now < validTo)
      );
    },
    /**
     * @param {PromoFile} file
     * @return {Promise<void>}
     */
    async updateFile(file) {
      try {
        const response = await axios.put(`/api/sec/files/${file.id}`, file, {
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
          },
        });
        const fileIndex = this.promoFiles.findIndex(
          (val) => val.id === file.id
        );
        this.$set(this.promoFiles, fileIndex, response.data.data);
        this.editingPromoFile = null;
      } catch (error) {
        this.displayValidationError(error);
      }
    },
    showDeleteDialog(file) {
      const toaster = this.$refs[`toaster${file.id}`][0];
      toaster.$data.dead = false;
      toaster.$data.doRender = true;
      this.$bvToast.hide();
      this.$bvToast.show(`delete-file-toast-${file.id}`);
    },
    /**
     * (soft) deletes a file
     * @param {PromoFile} file
     * @param {boolean} force
     * @returns Promise<void>
     */
    async deleteFile(file, force = false) {
      if (force) {
        URL.revokeObjectURL(this.blobUrls[file.id].full);
        URL.revokeObjectURL(this.blobUrls[file.id].thumbnail);
      }

      try {
        await axios.delete(`/api/sec/files/${file.id}`, {
          params: force
            ? {
                force: 1,
              }
            : {},
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
          },
        });
        await this.refresh();
      } catch (error) {
        this.error = error;
        this.displayValidationError(error);
      }
    },
    /**
     * restores a soft deleted file
     * @param file
     * @returns {Promise<void>}
     */
    async restoreFile(file) {
      try {
        await axios.put(`/api/sec/files/${file.id}?restore=1`, null, {
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
          },
        });
        await this.refresh();
      } catch (error) {
        this.error = error;
        this.displayValidationError(error);
      }
    },
    displayValidationError(error) {
      let valErrList = "";
      const errorData = error.response.data;
      if (errorData.errors) {
        const items = Object.entries(errorData.errors).map(([, valErr]) =>
          this.$createElement("li", [valErr.join(" ")])
        );
        valErrList = this.$createElement("ul", { class: "error-list" }, items);
      }
      const message = this.$createElement("p", [errorData.message, valErrList]);
      this.$bvToast.toast(message, {
        appendToast: true,
        autoHideDelay: 5000,
        toaster: "b-toaster-bottom-center",
        variant: "danger",
        title: "Fehler beim Speichern der Änderungen",
      });
    },
  },
  filters: {
    formatDate: (value) =>
      value ? moment(String(value)).format("DD.MM.YYYY HH:mm") : null,
  },
};
</script>

<style>
.files-table-container {
  width: 100%;
  margin-top: 2rem;
  color: var(--contrast-4);
}

/*.files-table {

}*/

.file-list {
}

.file-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--contrast-2);
  padding: 1rem;
}

.file-item.header-item {
  font-weight: bold;
  border-bottom: 1px solid var(--contrast-4);
}

.file-item .thumbnail {
  height: 100px;
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  border-top: 4px solid var(--contrast-1);
  border-left: 4px solid var(--contrast-1);
  cursor: pointer;
}

.thumbnail-active {
  border: 4px solid var(--success);
}

.thumbnail-inactive {
  border: 4px solid var(--danger);
}

.thumbnail-trashed {
  border: 4px solid var(--contrast-3);
}

.file-item .flex-1 {
  flex: 1;
  padding: 0 0.5rem;
  word-break: break-word;
}

.file-item .actions .button {
  width: 2.5rem;
  height: 2.5rem;
}

.file-item .actions .delete-toaster {
  position: absolute;
  right: 2rem;
  margin-top: -2.25rem;
}

.error-list {
  list-style-position: inside;
}
</style>
